/**
 * Created by rhett on 2019/4/12.
 */

import React, {Component} from 'react';
import "./ComingActivityLi.css"

export default class ComingActivityLi extends Component
{


  componentDidMount()
  {
  }

  render()
  {
    let {img , title,desc} = this.props;
    return (
      <div className="ComingActivityLi" style={{backgroundImage:("url('" + img + "')")}}>
        <div className="title">{title}</div>
        <div className="desc">{desc}</div>
      </div>);
  }

}